import { Sistema } from "./sistema";
import { Usuario } from "./usuario";

export class AvaliacaoSistema {
  idAvaliacaoSistema: number = null; //Chave prim�ria - Identifica��o �nica
  sistema: Sistema; //Chave estrangeira para o sistema
  usuario: Usuario; //Chave estrangeira para o usu�rio
  dtAvaliacao: Date = null;
  snAtivo: string = null;
  nrAvaliacao: number = null;

  constructor(d?) {
    if (d) {
      this.idAvaliacaoSistema = d.idAvaliacaoSistema
        ? d.idAvaliacaoSistema
        : null;
      this.sistema = d.sistema ? new Sistema(d.sistema) : null;
      this.usuario = d.usuario ? new Usuario(d.usuario) : null;
      this.dtAvaliacao = d.dtAvaliacao ? d.dtAvaliacao : null;
      this.snAtivo = d.snAtivo ? d.snAtivo : null;
      this.nrAvaliacao = d.nrAvaliacao ? d.nrAvaliacao : null;
    }
  }
}
